module.exports = __webpack_public_path__ + "media/images/svg/credit-cards-payment-d9249856dc8c83c66aa87c2a5a5bc364.svg";